//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';
import messageBox from '@/components/messageBox';
import { getPipelineList } from '@/graphql/api/build.js';
import createDialog from './create';
import detailDrawer from './detail';
import { CosMixin } from '@/mixins/cos';
import { GetKvlist } from '@/api/kv.js';
import { whereGql } from '@/graphql/util';

export default {
  components: {
    messageBox,
    createDialog,
    detailDrawer,
  },
  mixins: [CosMixin],
  data() {
    return {
      tab: 'mp',
      loading: false,
      search: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      list: [],
      editJson: '',
      editId: '',
      showCreate: false,
      showDetail: false,
      detailData: {},
      buildStatus: {
        pending: '构建中',
        success: '构建成功',
        failed: '构建失败',
      },
      apiUrl: {
        h5: '/api/access/pb/cmd/BuildServer/BuildService/BuildCustomH5',
        web: '/api/access/pb/cmd/BuildServer/BuildService/BuildCustomWeb',
        mp: '/api/access/pb/cmd/BuildServer/BuildService/BuildMp',
      },
      refreshTimer: null, // 定时刷新定时器
      env: process.env.NODE_ENV,
      kvConfig: {},
    };
  },
  computed: {
    ...mapGetters('user'),
    isProduction() {
      return this.tab === 'mp' && this.env === 'production';
    },
  },
  async created() {
    await this.getKvConfig();
    this.getList();
  },
  beforeDestroy() {
    // 组件销毁时清除定时器，防止内存泄漏
    this.clearRefreshTimer();
  },
  mounted() {},
  methods: {
    ...mapActions('user'),
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    hasPendingItem() {
      return this.list.some((item) => item.status === 'pending');
    },
    handleRefreshTimer() {
      const hasPending = this.hasPendingItem();
      if (hasPending) {
        if (!this.refreshTimer) {
          this.refreshTimer = setInterval(() => {
            this.getList(false);
          }, 8000);
        }
      } else {
        this.clearRefreshTimer();
      }
    },
    async getList(init = true) {
      if (init) this.loading = true;
      try {
        const res = await getPipelineList({
          platform: this.tab,
          limit: this.search.page_size,
          offset: this.search.page_size * (this.search.page - 1),
        });
        this.list = res?.front_end_build_log?._data || [];
        this.total = res?.front_end_build_log?._aggregate.count;
      } catch (err) {
        console.log(err);
      } finally {
        if (init) this.loading = false;
        this.handleRefreshTimer();
      }
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
    stopPipeline() {},
    publish(data) {
      this.$request({
        url: this.apiUrl[this.tab],
        data,
      }).then(() => {
        this.showCreate = false;
        this.$message.success('执行成功');
        this.getList();
      });
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    handleTabChange() {
      this.clearRefreshTimer();
      this.getList();
    },
    openDetail(data) {
      this.detailData = data;
      this.showDetail = true;
    },
    calculateBuildDuration(start, end) {
      const totalSeconds = Math.abs(end - start);
      const hours = Math.floor(totalSeconds / 3600);
      const remainingSecondsAfterHours = totalSeconds % 3600;
      const minutes = Math.floor(remainingSecondsAfterHours / 60);
      const seconds = remainingSecondsAfterHours % 60;
      const parts = [];
      if (hours > 0) {
        parts.push(`${hours}小时`);
      }
      if (minutes > 0) {
        parts.push(`${minutes}分钟`);
      }
      if (parts.length === 0 || seconds > 0) {
        parts.push(`${seconds}秒`);
      }
      return parts.join('');
    },
    downloadUrlHttp(url, filename) {
      const x = new window.XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        if (window.downLink) window.downLink = null;
        window.downLink = document.createElement('a');
        window.downLink.href = url;
        window.downLink.style.display = 'none';
        window.downLink.download = filename;
        window.downLink.click();
      };
      x.send();
    },
    async download(url, name) {
      const publicUrl = await this.getPrivateUrl(url);
      this.downloadUrlHttp(publicUrl, name);
    },
    async getKvConfig() {
      try {
        const res = await GetKvlist({
          limit: 1,
          offset: 0,
          tableName: 'kv',
          filter: whereGql([
            {
              whereGqlType: 'is',
              key: `front_end_build_config`,
            },
          ]),
        });
        const kv = res?.kv._data?.[0] || {};
        const preData = JSON.parse(kv?.value || '{}')?.[this.tab] || {};
        this.kvConfig = preData;
      } catch (error) {
        console.error('getKvConfig error', error);
      }
    },
    manage() {
      console.log('manage kvConfig', this.kvConfig.TARGET_APP_ID);
      this.$router.push({
        name: 'mini-verson-detail',
        query: {
          appid: this.kvConfig.TARGET_APP_ID,
          active: 'first',
        },
      });
    },
  },
};
